import React from "react";

const UltraLibrarianPopup = ({ data, SetStatus }) => {
  const { manufacturerSlug, partNumber } = data || {};

  if (!manufacturerSlug || !partNumber) return null;

  const ulUrl = `https://vendor.ultralibrarian.com/avnet/embedded?mfrName=${manufacturerSlug}&mfrPN=${encodeURIComponent(partNumber)}`;
  const iframeHeight = Math.min(window.innerHeight * 0.95 - 10, 600);

  return (
    <>
      <div style={{ position: "fixed", inset: 0 }} onClick={() => SetStatus(false)} />
      <div className="avnet-modal modal-940" onClick={(e) => e.stopPropagation()}>
        <div className="avnet-modal-inner" style={{ position: "relative", overflow: "hidden" }}>
          <button
            type="button"
            className="close py-3"
            data-dismiss="modal"
            onClick={() => SetStatus(false)}
            style={{ position: "absolute", top: 0, right: 0, zIndex: 10 }}
          >×</button>
          <iframe
            src={ulUrl}
            title="Ultra Librarian PCB Symbol, Footprint & 3D Model"
            width="100%"
            height={iframeHeight}
            style={{ border: "none", display: "block", marginTop: "45px" }}
          />
        </div>
      </div>
    </>
  );
};

export default UltraLibrarianPopup;
